<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="当前通道" class="EL-Form-Item">
                        <el-select v-model="mainSearch.whCode" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.matCode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.boxBarcode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="mainSearchMat.fcCode">
                    <el-form-item label="规值" class="EL-Form-Item">
                        <el-input v-model="mainSearchMat.matSpecs" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getLcCodeAllByInput()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetTop">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!mainSearch.fcCode">
                    <el-form-item label="规值" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matSpecs" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="产线点位配置">
                <el-button v-authority="'BACK_MENU3_M13_B1'" class="btn-t-edit" @click="updatePointMsg()">修改点位配置</el-button>       
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getLcCodeAllByInput" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" @selectionChange="selectMain">
                <el-table-column type="selection" align="center"/>
                <el-table-column label="点位" align="center" prop="lrRealCode" />
                <el-table-column label="点位类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lrPointType == '10'">装配</span>
                        <span v-if="scope.row.lrPointType == '20'">锻圈</span>
                    </template>
                </el-table-column>
                <el-table-column label="通道编号" align="center" prop="lineCode" />
                <el-table-column label="点位配置" align="center" prop="lrOtherType">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.lrOtherType" ></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="点位状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.occupyFlag == true">占用</span>
                        <span v-if="scope.row.occupyFlag == false">空闲</span>
                    </template>
                </el-table-column>
            </h-table>
        </box>
    </div>
</template>

<script>
    import vPrint from 'syl-vue-printer'
    import plabel from '../../components/public/plabel.vue';
    import moment from 'moment'
    export default {
        components: {
            plabel
        },
        components: {
            vPrint
        },
        name: "PointConfiguration",
        data() {
            return {
                titleType: "",
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                // 筛选条件
                mainSearch: {
                    person: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                    smCode: "",
                    matCode: "",
                    boxBarcode: "",
                    status: "CREATE,REJECT",
                    matSpecs: "",
                    matLenValue: "",
                    date: [],
                },
                whCodeId: "",
                warehouseList: [],
                warnTypeList: [],
                boxSpecs: [],
                resd: 0,
                //多选
                checkListMain: [],
                //工厂信息
                factory: {},
                //箱号
                BoxBarcodeList: [],
                //退料料箱
                returnInfo: {
                    whCode: localStorage.getItem("whCode") || "",
                    boxBarcode: "",
                    bsCode: "",
                    matCode: "",
                    matCodes: "",
                    whCodeBack: "",
                    lcCode: "",
                    distrType: "",
                    wtName: "",
                    boxQuan: "",
                    matName: "",
                    matSpecs: "",
                    matLenValue: "",
                    beginTime: "",
                    boxHeight: "",

                },
                returnList: [],

                person: localStorage.getItem("user"),

                downloadLoading: false, //下载中
                downloadLoadingMat: false, //下载中
                insertStockPrintBarcodes: false,
                insertInventoryLists: false,
                insertStockReturnMats: false,


                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                //记录判断
                otherRecordList: [],

                //打印
                print: false,
                printShow: false,
                printList: [],
                timeDate: '',

                workCenter: '', //成本中心

                dialogShowVirtual: false,
                virtuallcCode: "",
                virtualInventoryList: [],

                //agv搬运产线点位
                sysLineRouterList: [],

                //退料通道库存
                wipOutInventoryList: [],
                wipMatCode: '',
                //选中的库存
                wipOutSelectList: [],
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            mainSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getLcCodeAllByInput(newVal);
                    }, 1000);
                },
                deep: true,
            },
        },

        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy);
                window.lazy = window.setTimeout(() => {
                    this.getLcCodeAllByInput();
                }, 1000);
            },   
            /**
             * 修改点位配置
             */
            updatePointMsg(){
                this.$http
                    .request({
                        url: "/api/sysLineRouter/updateLineRouter",
                        method: "POST",
                        data: this.checkListMain
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                message: "修改成功！",
                                type: "success",
                            });
                        }else{
                            this.$message({
                                message: resp.message,
                                type: "warning",
                            });
                        }
                        this.getLcCodeAllByInput();
                    })
                    .catch((error) => {
                        this.loading++;
                        this.$message({
                            message: resp.message,
                            type: "warning",
                        });
                    });
            },
             /**
             * 通道列表
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },   
            /**
             * 查询所有产线的上料口
             */
            getLcCodeAllByInput() {
                this.$http
                    .request({
                        url: "/api/sysLineRouter/getLcCodeAllByInput",
                        method: "GET",
                        params: {
                            fcCode: this.mainSearch.fcCode || null,
                            whCode: this.mainSearch.whCode || null,
                            pageNum: this.mainData.nowPage,
                            pageSize: this.mainData.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData.data = resp.data.list || [];
                            this.mainData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {});
            },
           

           
            selectWipOutInventory(val) {
                this.wipOutSelectList = val;
            },
            /**
             * 多选
             */
            selectMain(val) {
                this.checkListMain = val;
            },
            /**
             * 重置
             */
            resetTop() {
                this.mainSearch = {
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "",
                };
                this.getLcCodeAllByInput();
            },

            //表格导出
            downLoadFileMat() {
                this.downloadLoadingMat = true;
                var paramsObj = {
                    matCode: this.mainSearchMat.matCode || null,
                    boxBarcode: this.mainSearchMat.boxBarcode || null,
                    matSpecs: this.mainSearchMat.matSpecs || null,
                    matLenValue: this.mainSearchMat.matLenValue || null,
                    whCode: this.mainSearchMat.whCode || null,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/location/getSysLocationPage',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoadMat(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoadMat(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.wiStatus == 'NORMAL') {
                            c['wiStatus'] = '正常'
                        } else if (c.wiStatus == 'FREEZE') {
                            c['wiStatus'] = '冻结'
                        } else if (c.wiStatus == 'OVERTIME') {
                            c['wiStatus'] = '过期'
                        } else if (c.wiStatus == 'DELETE') {
                            c['wiStatus'] = '作废'
                        } else if (c.wiStatus == 'AGFREEZE') {
                            c['wiStatus'] = '人工冻结'
                        } else {
                            c['wiStatus'] = ''
                        }
                    })

                    const tHeader = ['通道编号', '物料编号', '物料描述', '数量', '批次号', '货位号', '箱号', '规值', '日期', '产品状态', '地面位置', '记录状态',
                        '记录时间'
                    ]
                    const filterVal = ['whCode', 'matCode', 'matName', 'matQuan', 'batchNo', 'lcCode', 'boxBarcode', 'matSpecs', 'matCreateTime',
                        'wiStatus', 'routerCode', 'recordStatus', 'recordDate'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '通道物料'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory：导出通道物料记录"
                    this.systemLog();
                    this.downloadLoadingMat = false
                })
            },
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    fcCode: this.mainSearch.fcCode || null,
                    whCode: this.mainSearch.whCode || null,
                    smCode: this.mainSearch.smCode || null,
                    matCode: this.mainSearch.matCode || null,
                    boxBarcode: this.mainSearch.boxBarcode || null,
                    status: this.mainSearch.status || null,
                    beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                    endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/stockReturnMat/getStockReturnMatPage',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.spStatus == 'CREATE') {
                            c['spStatus'] = '创建'
                        } else if (c.spStatus == 'WAIT') {
                            c['spStatus'] = '待上架'
                        } else if (c.spStatus == 'REJECT') {
                            c['spStatus'] = '驳回'
                        } else if (c.spStatus == 'UPPERING') {
                            c['spStatus'] = '上架中'
                        } else if (c.spStatus == 'CONFIRM') {
                            c['spStatus'] = '完成'
                        }

                        if (c.distrType == '20') {
                            c['distrType'] = '人工退料'
                        } else if (c.distrType == '10') {
                            c['distrType'] = 'AGV退料'
                        }
                    })
                    const tHeader = ['通道编号', '退料单号', '退料状态', '退料数量', '退料方式', '操作人员', '创建时间', '修改时间']
                    const filterVal = ['whCode', 'smCode', 'spStatus', 'matQuan', 'distrType', 'person', 'createTime', 'updateTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '生产退料'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_return_mat：导出生产退料记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            //打印

            /**
             * 全选
             */
            selectAllMain(val) {
                this.checkListMain = val;
            },

            /**
             * 禁选
             */
            checkboxMain(row, rowIndex) {
                // if (row.status == "CREATE") {
                return true; // 不禁用
                // } else {
                // return false; // 禁用
                // }
            },
            prints(smCode) {
                // if (this.checkListMain.length == 0) {
                //     this.$message({
                //         message: "请选择打印单！",
                //         type: "warning",
                //     });
                //     return
                // }
                // let list = []
                // this.checkListMain.forEach((item) => {
                //     list.push(item.smCode)
                // })
                // var smCode = list.join(",")
                this.$http
                    .request({
                        url: "/api/stockReturnMat/getStockReturnMatList",
                        method: "GET",
                        params: {
                            smCode: smCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.list != null) {
                                this.printList = resp.data.list;
                                this.workCenter = resp.data.list[0].workCenter
                                this.printShow = true;
                                this.getTime()

                            } else {
                                this.$message({
                                    message: "未找到打印记录！",
                                    type: "warning",
                                });
                                return
                            }
                        }
                    })
                    .catch((error) => {});
            },
            printObjList() {
                let code = [];
                for (let i in this.printList) {
                    code.push(this.printList[i].sorCode)
                }
                let stringCode = code.join(",")
                this.$http
                    .request({
                        url: "api/stockPrintDocument/insertStockPrintDocument",
                        method: "POST",
                        showLoading: true,
                        params: {
                            operaCode: stringCode,
                            operaType: '10',
                            fcCode: localStorage.getItem("fcCode") || "",
                            person: localStorage.getItem("user"),
                            personNumber: localStorage.getItem("empNumber"),
                        },
                    })
                    .then((resp) => {})
                    .catch((error) => {});
            },
            /**
             * 获取当前时间
             * 格式YYYY-MM-DD
             */
            getTime() {
                var date = new Date();
                var seperator1 = "/";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                this.timeDate = year + seperator1 + month + seperator1 + strDate;
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "生产退料",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            this.getWarehouse();
            /* 获取首页的数据 */
            this.getLcCodeAllByInput();
        },
    };
</script>
<style scoped>
    .div div {
        width: 170px;
        height: 50px;
        /* border: 1px solid black; */
        margin-left: 10px;
        margin-top: 10px;
        float: left;
        font-weight: 550;
        font-size: 18px;
    }

    .table table {
        margin-top: 3px;
    }

    .table table tr td {
        width: 130px;
        height: 50px;
        border: 1px solid black;
        text-align: center;
        font-size: 14px;
        font-weight: 800;
        color: black;
    }

    .table table tr th {
        width: 175px;
        height: 50px;
        border: 1px solid black;
        font-weight: 800;
        font-size: 18px;
        color: black;
    }

    .td td {
        font-weight: 800;
        color: black;
    }

    .color {
        background: rgb(194, 192, 192);
        color: black;
    }
</style>